/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_CountryInputs */

const en_admin_external_booking_edit_country = /** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const de_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const es_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const fr_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const it_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const pl_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const hu_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/** @type {(inputs: Admin_External_Booking_Edit_CountryInputs) => LocalizedString} */
const ro_admin_external_booking_edit_country = en_admin_external_booking_edit_country;

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Admin_External_Booking_Edit_CountryInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_country = /** @type {((inputs?: Admin_External_Booking_Edit_CountryInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_CountryInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_country(inputs)
	if (locale === "de") return de_admin_external_booking_edit_country(inputs)
	if (locale === "es") return es_admin_external_booking_edit_country(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_country(inputs)
	if (locale === "it") return it_admin_external_booking_edit_country(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_country(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_country(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_country(inputs)
	return ro_admin_external_booking_edit_country(inputs)
});
export { admin_external_booking_edit_country as "admin.external_booking_edit.country" }